<template>
  <div>
    <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>

    <div class="row mx-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass">
      </b-select>
      <b-input 
        id="search-input" 
        class="col-md-6 col-lg-4 ml-2 mb-2 mb-sm-0" 
        :placeholder="$t('training-view.searchBy')"
        v-model="searchString"
      ></b-input>
    </div>
    <b-table 
      :busy="loading"
      :items="participations"
      :fields="fields"
      :filter="searchString"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="participantsTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    > 
      <template v-slot:cell(rejectComments)="row">
        <b-input v-model="row.item.rejectComments" :placeholder="((row.item.status =='ACCEPTED' && activity.status != 'APPROVED' )|| row.item.status == 'REJECTED' || row.item.status == 'COMPLETED'  || row.item.status == 'FAILED' || row.item.status == 'UNDER_REVIEW') ? '' : $t('training-view.requiredComments')  "
          :disabled="(activity.status !== 'SCHEDULED' && activity.status !== 'APPROVED' && activity.status != 'TO_BE_COMPLETED' || row.item.status == 'UNDER_REVIEW')">
        </b-input>
      </template>

      <template v-slot:cell(action)="row">
        <template v-if="row.item.status === 'UNDER_REVIEW'">
          <b-icon icon="shield-x" variant="warning"             v-b-tooltip.hover
                  :title="$t('training-view.notApproved')"></b-icon>
        </template>
        <template v-else-if="row.item.status === 'AWAITING_PAYMENT'">
          <b-icon icon="cart-x" variant="danger"             v-b-tooltip.hover
                  :title="$t('training-view.pendingPayment')"></b-icon>
        </template>
        <template v-else>
        <template v-if="activity.status === 'SCHEDULED' && row.item.status != 'UNDER_REVIEW' && row.item.status != 'AWAITING_PAYMENT'">
          <b-button
            size="sm"
            @click="acceptTrainee(row)"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('training-view.acceptTrainee')"
          >
            <b-icon icon="person-check" :variant="row.item.status == 'ACCEPTED' ? 'success' : 'transparent'"></b-icon>
          </b-button>
          <b-button
            size="sm"
            @click="rejectTrainee(row)"
            :disabled="!row.item.rejectComments"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('training-view.rejectTrainee')"
          >
            <b-icon icon="person-x" :variant="row.item.status === 'REJECTED' ? 'danger' : 'transparent'"></b-icon>
          </b-button>
        </template>
        <template v-else-if="activity.status === 'APPROVED' || activity.status === 'TO_BE_COMPLETED'">
          <b-button
            size="sm"
            @click="completeTrainee(row)"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('training-view.completeTrainee')"
          >
            <b-icon icon="person-check" :variant="row.item.status === 'COMPLETED' ? 'success' : 'transparent'"></b-icon>
          </b-button>
          <b-button
            size="sm"
            @click="failedTrainee(row)"
            variant="transparent"
            :disabled="!row.item.rejectComments"
            v-b-tooltip.hover
            :title="$t('training-view.failedTrainee')"
          >
            <b-icon icon="person-x" :variant="row.item.status === 'FAILED' ? 'danger' : 'transparent'"></b-icon>
          </b-button>
        </template>
        <b-button
          size="sm"
          variant="transparent"
          v-b-tooltip.hover
          :href="`${routes.members.member.edit}/${row.item.member.id}` "
          target="_blank"
          :title="$t('training-view.showTrainee')"
          v-if="isAdmin || isTrainingAdmin"
        >
          <b-icon icon="eye"></b-icon>
        </b-button>

        </template>

      </template>

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyTraineesTable") }}</h6>
      </template>

      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="members-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {routes} from "../../services/routing.service.js";
import trainingService from '../../services/training.service.js';
import { handleApiError } from "../../services/error.service";

export default {
  computed: {
    rows() {
      return this.participations? this.participations.length : 0;
    }
  },
  props: {
    activity: {
      type: Object
    }
  },
  mounted() {
    this.getActivitysParticipations();
    this.fetchRoles();
  },
  data() {
    return {
      isAdmin: false,
      isTrainingAdmin: false,
      popSuccessAlert: false,
      successMessage: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "member",
      sortDesc: false,
      fields: [
        { key: "member.id", label: "Α.Μ.", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "member", label: "Ονοματεπώνυμο", sortable: true, sortByFormatted: true, filterByFormatted: true, formatter: "formatFullName", thClass: 'text-left', tdClass: 'text-left'},
        { key: "member.cinfo.telNo", label: "Τηλέφωνο", sortable: false }, 
        { key: "member.cinfo.cellNo", label: "Κινητό", sortable: false },
        { key: "member.cinfo.email", label: "e-mail", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "rejectComments", label: "Αιτιολογία Απόρριψης", sortable: false, thClass: 'text-left', tdClass: 'text-left' }, 
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      filterOn: ["memberId", "member"],
      searchString: "",
      routes: routes,
      loading: false,
      participations: null
    }
  },
  methods: {
    fetchRoles() {
      let userInfo = this.$store.state.userInfo;
      for(var i=0; i< userInfo.roles.length; i++){
        if(userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    },
    getActivitysParticipations() {
      this.loading = true;
      trainingService.getActivitysParticipations(this.activity.id).then(
        (response) => {
          this.$log.debug("participations")
          this.$log.debug(response.data);
          let temp = [];
          response.data.forEach(
            participation => {
              participation.memberId = participation.member.id;
              temp.push(participation);
            }
          )
          this.participations = response.data;
          this.loading = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    acceptTrainee(row) {
      // this.$log.debug(row.item.id);
      trainingService.updateParticipationStatus(row.item.id, 'ACCEPTED').then(
        (response) => {
          this.updateParticipationList(row.item, response, 'training-view.accepted')
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    rejectTrainee(row) {
      trainingService.updateParticipationStatus(row.item.id, 'REJECTED', row.item.rejectComments).then(
        (response) => {
          this.updateParticipationList(row.item, response, 'training-view.rejected')
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    completeTrainee(row) {
      trainingService.updateParticipationStatus(row.item.id, 'COMPLETED').then(
        (response) => {
          this.updateParticipationList(row.item, response, 'training-view.completed')
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    failedTrainee(row) {
      trainingService.updateParticipationStatus(row.item.id, 'FAILED', row.item.rejectComments).then(
        (response) => {
          this.updateParticipationList(row.item, response, 'training-view.failed')
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    updateParticipationList(item, response, message){
      this.successMessage = `${item.member.surName} ${item.member.firstName}: ${this.$t(message)}`;
      this.popSuccessAlert = true;
      this.participations = this.participations.map(obj => obj.id === item.id? response.data: obj);
    },
    search() {
      if(this.searchString.length > 2) {
        this.$log.debug(this.searchString)
      }
    },
    formatFullName(member) {
      return member.surName +" " + member.firstName;
    },
  }
}
</script>